import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openModal: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    toggleModal: (state, action) => {
      state.openModal = !state.openModal;
    },
  },
});

export const { toggleModal } = modalSlice.actions;
export default modalSlice.reducer;
